import React, { useState, useEffect } from "react";
import { AppBar, Toolbar, Button, Box, Avatar } from "@mui/material";
import NavMenu from "./NavMenu";
import { getSchoolLogo } from "../ApiService/ApiService";
import { Link, useNavigate } from "react-router-dom";
import newLogo from "../static/newLogo.png";

const Navbar = (props) => {
  const navigate = useNavigate();
  const userProficPic = sessionStorage.getItem("profileImage");
  const tokenFromLocal = sessionStorage.getItem("token");
  const schoolId = sessionStorage.getItem("schoolId");
  const [schoolLogo, setSchoolLogo] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const fetchSchoolLogo = async (schoolId) => {
    const response = await getSchoolLogo(schoolId);
    setSchoolLogo(response?.data?.data?.url);
  };

  useEffect(() => {
    fetchSchoolLogo(schoolId);
    setIsLoggedIn(tokenFromLocal !== null);
  }, [schoolId, tokenFromLocal]);

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <AppBar position="static" style={{ backgroundColor: "#2659c8" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Link to="/">
          {" "}
          <Avatar
            src={schoolLogo ? schoolLogo : newLogo}
            sx={{ width: 50, height: 50, marginRight: 1 }}
          />
        </Link>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          {!isLoggedIn && <NavMenu />}
          {isLoggedIn ? (
            <Avatar
              src={userProficPic}
              alt="Profile"
              sx={{
                height: 40,
                width: 40,
                border: "1px solid gray",
                marginLeft: 1,
                marginRight: 1,
              }}
            />
          ) : (
            <Button
              variant="contained"
              color="success"
              size="small"
              fullWidth
              onClick={handleLoginClick}
              sx={{
                textTransform: "unset",
                borderRadius: 1,
                height: 40,
                width: 100,
                marginTop: 1,
                marginLeft: 1,
                marginBottom: 1,
              }}
            >
              Login
            </Button>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
